var mutation = {
  // 设置当前部门
  setnodepartitle(state, title) {
    state.nodepartitle = title;
  },
  //设置加入部门列表
  sethasdepart(state, title) {
    state.departmentlist = title;
  },
  //设置部门列表
  sethasdepartall(state, title) {
    state.departmentall = title;
  },
  //设置资源
  setdedata(state, { data, key }) {
    state[key] = data;
  },
  // 设置
  setData(state, { data, field }) {
    console.log("设置", state, field, data);
    data && (state[field] = data);
  },
  //对state中的元素进行压栈操作
  pushData(state, { data, field }) {
    data && state[field].push(data);
  },
  //对state中的元素进行裁切操作
  spliceData(state, { start, num, field }) {
    state[field].splice(start, num);
  }
};
export default mutation;



// WEBPACK FOOTER //
// ./src/store/modules/department/mutation.js